import { AxiosResponse } from "axios";
import { AccessibilityUnitLevel, AccessibilityUnitLevelRequest } from "../models/AccessibilityUnitLevel";
import { AccessibilityUnitsQuery } from "../models/AccessibilityUnits";
import axios from "../utils/axios";
import { BasicQuerySearch } from "./utilts";

export function fetchUnitsAll(token: string, query:BasicQuerySearch = {},) {
  return new Promise<AxiosResponse<AccessibilityUnitsQuery>>((resolve, reject) => {
    axios
      .get(`${process.env.REACT_APP_API_DOMAIN}/accessibility-units/`, {
        headers: { Authorization: "Token " + token },
        params: query
      })
      .then((response) => {
        if (response.status === 200) {
          resolve(response as any);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function fetchUnits(property: string, token: string) {
  return new Promise<AxiosResponse<AccessibilityUnitsQuery>>((resolve, reject) => {
    axios
      .get(`${process.env.REACT_APP_API_DOMAIN}/accessibility-units/?property__id=${property}&limit=999`, {
        headers: { Authorization: "Token " + token },
      })
      .then((response) => {
        if (response.status === 200) {
          resolve(response as any);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function createUnit(data: object, token: string) {
  return new Promise((resolve, reject) => {
    axios
      .post(`${process.env.REACT_APP_API_DOMAIN}/accessibility-units/`, data, {
        headers: { Authorization: "Token " + token },
      })
      .then((response) => {
        if (response.status === 201) {
          resolve(response);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function updateUnit(data: Partial<AccessibilityUnitLevelRequest>, token: string, id: string) {
  return new Promise((resolve, reject) => {
    axios
      .patch(`${process.env.REACT_APP_API_DOMAIN}/accessibility-units/${id}/`, data, {
        headers: { Authorization: "Token " + token },
      })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function deleteUnit(token: string, id: string) {
  return new Promise((resolve, reject) => {
    axios
      .delete(`${process.env.REACT_APP_API_DOMAIN}/accessibility-units/${id}/`, {
        headers: { Authorization: "Token " + token },
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function fetchUnitsLevels(property: string, token: string) {
  return new Promise((resolve, reject) => {
    axios
      .get(`${process.env.REACT_APP_API_DOMAIN}/accessibility-unit-levels/?accessibility_unit=${property}`, {
        headers: { Authorization: "Token " + token },
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function createUnitLevels(data: AccessibilityUnitLevelRequest, token: string) {
  return new Promise<AxiosResponse<AccessibilityUnitLevel>>((resolve, reject) => {
    axios
      .post(`${process.env.REACT_APP_API_DOMAIN}/accessibility-unit-levels/`, data, {
        headers: { Authorization: "Token " + token },
      })
      .then((response) => {
        if (response.status === 201) {
          resolve(response);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function updateUnitLevels(data: AccessibilityUnitLevelRequest, token: string, id: string) {
  return new Promise<AxiosResponse<AccessibilityUnitLevel>>((resolve, reject) => {
    axios
      .put(`${process.env.REACT_APP_API_DOMAIN}/accessibility-unit-levels/${id}/`, data, {
        headers: { Authorization: "Token " + token },
      })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}


export function deleteUnitLevels(token: string, id: string) {
  return new Promise<any>((resolve, reject) => {
    axios
      .delete(`${process.env.REACT_APP_API_DOMAIN}/accessibility-unit-levels/${id}/`, {
        headers: { Authorization: "Token " + token },
      })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}


